<template>
  <div class="home scrollSp">
    <top-menu :userName="userName" :menusList="dashboardMenus" :customMenuItems="dashboardMenuItems" @tologin="toLogin" @showPersonCenter="showPersonCenter"></top-menu>
    <bdMap></bdMap>

      <!-- ponytail: nearby enterprises picker when multiple overlap -->
      <GlassPopup
        :show="showNearbyList"
        title="选择企业"
        @close="showNearbyList = false">
        <template #title-icon>
          <IconSet name="info-circle" />
        </template>
        <div class="listCon" style="height: 260px;">
          <div class="listItem bluebg">
            <span class="firsp">#</span>
            <span class="secsp">企业名称</span>
            <span class="thisp">风险等级</span>
            <span class="forsp">操作</span>
          </div>
          <div class="listItem trFont" v-for="(item , index) in nearbyList" :key="index">
            <span class="firsp">
              <IndexBadge>{{ index+1 }}</IndexBadge>
            </span>
            <span class="secsp">{{ item.deptName }}</span>
            <span class="thisp">
              <span class="risk-level-badge" :class="'risk-' + (item.mostSeriousRiskLevelName || 'low')">{{ item.mostSeriousRiskLevelName || '暂无' }}</span>
            </span>
            <span class="forsp">
              <button class="sta-action-btn" @click="selectEnterprise(item)">查看</button>
            </span>
          </div>
        </div>
      </GlassPopup>

      <GlassPopup
        :show="showMapPopup"
        title=""
        width="400px"
        @close="showMapPopup = false">
        <div class="glass-map-content">
          <div class="glass-map-title">{{ selectedPoint.deptName }}</div>
          <div class="map-stats-grid">
            <div class="map-stat-item">
              <span class="stat-label">监测点总数</span>
              <span class="stat-value">{{ mapPointList.totalPoint || 0 }}</span>
            </div>
            <div class="map-stat-item stat-warn">
              <span class="stat-label">中高危监测点</span>
              <span class="stat-value" :class="{ 'stat-danger': mapPointList.highRiskPoint > 0 }">{{ mapPointList.highRiskPoint || 0 }}</span>
            </div>
          </div>
          <div class="mapButton">
            <button class="sta-action-btn" @click="goStation">进入</button>
          </div>
        </div>
      </GlassPopup>

      <GlassPopup
        :show="showpage2"
        title="监测点列表"
        @close="showpage2 = false">
        <template #title-icon>
          <IconSet name="info-circle" />
        </template>
        <div class="listCon" style="height: 240px;">
          <div class="listItem bluebg">
            <span class="firsp">#</span>
            <span class="secsp">单位名称</span>
            <span class="thisp">监测点名称</span>
            <span class="forsp">操作</span>
          </div>
          <div class="listItem trFont" v-for="(item , index) in RiskTable" :key="index">
            <span class="firsp">
              <IndexBadge>{{ index+1 }}</IndexBadge>
            </span>
            <span class="secsp">{{ item.deptName }}</span>
            <span class="thisp">{{ item.siteName }}</span>
            <span class="forsp">
              <button class="sta-action-btn" @click="toDetail(item)">查看</button>
            </span>
          </div>
        </div>
        <div class="sta-pagination">
          <el-pagination
            @current-change="pageChange"
            background
            :current-page="page"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="pageall">
          </el-pagination>
        </div>
      </GlassPopup>

      <GlassPopup
        :show="showtc"
        title="监测点列表"
        @close="showtc = false">
        <template #title-icon>
          <IconSet name="warning-triangle" />
        </template>
        <div class="listCon" style="flex:1;">
          <div class="listItem bluebg">
            <span class="firsp">#</span>
            <span class="secsp">监测点名称</span>
            <span class="thisp">隐患名称</span>
            <span class="forsp">隐患等级</span>
          </div>
          <div class="listItem trFont" v-for="(item , index) in tableList" :key="index">
            <span class="firsp">
              <IndexBadge>{{ (tcPage - 1) * tcPageSize + index + 1 }}</IndexBadge>
            </span>
            <span class="secsp">{{ item.siteName }}</span>
            <span class="thisp">{{ item.simpleMess }}</span>
            <span class="forsp">
              <span class="risk-level-badge" :class="'risk-' + (item.riskLevelName || 'low')">{{ item.riskLevelName }}</span>
            </span>
          </div>
        </div>
        <div class="tc-pagination">
          <el-pagination
            @size-change="handleTcSizeChange"
            @current-change="handleTcCurrentChange"
            background
            :current-page="tcPage"
            :page-size="tcPageSize"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tcTotal">
          </el-pagination>
        </div>
      </GlassPopup>
      <SiteListDrawer
        :visible.sync="drawerVisible"
        :title="drawerTitle"
        :tabs="drawerTabs"
        :default-tab-index="drawerDefaultTab"
        :dept-id="deptId"
      />
      <div class="homeItem">
        <div class="topItem">
          <div class="topLeft">
            <!--安全-左侧板块-->
            <left-panel
              v-show="safePart"
              ref="leftPanel"
              :filterText.sync="filterText"
              :organizationTree="organizationTree"
              :enterpriseTotal="enterpriseTotal"
              :lastMonthNew="lastMonthNew"
              :loading="leftPanelLoading"
              @search="searchData"
              @node-click="handleNodeClick"
            />

            <!--能源-左侧板块-->
            <left-energy
              v-show="energyPart"
              :last-month-data = "lastMonthData"
              :all-energy-data = "allEnergyData"
              :loading="leftEnergyLoading"
            />
          </div>
          <div class="topRight">
            <div class="topCenter">
              <!-- ponytail: skip skeleton for top cards — always show content directly -->
              <template v-if="!titleDataLoading">
                <div class="topPart" v-for="(item,index) in titleData" :key="index">
                  <div>{{ t('risk_' + item.code) }}</div>
                  <div class="itemNum" @click="opentc(index)">{{ item.totalCount }}</div>
                  <div class="page1" v-show="showpage[index]">
                    <div class="pageItem" @click="selectpage(group)" v-for="group in item.alertLevelRiskCounts" :key="group.alertLevelName">
                      <div>{{ t('alert_' + group.alertLevel) }}</div>
                      <div style="width: 20%; text-align: end">{{ group.count }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="change-part">
              <div class="change-item" :class="{ active: safePart }" @click="goToSafe">
                <div class="change-text">{{ t('safe') }}</div>
              </div>
              <div class="change-item" :class="{ active: energyPart }" @click="goToEnergy">
                <div class="change-text">{{ t('energy') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottomItem">
          <!--安全-底部板块-->
          <bottom-panel
            v-show="safePart"
            :hidden-data="hiddenData"
            :equipment-data="EquipmentData"
            :high-risk-data="highRiskData"
            :pie-data="pieData"
            :combined-data="combinedData"
            :risk-list="riskList"
            :total-type-point="totalTypePoint"
            :point-total="PointTotal"
            :power-point="powerPoint"
            :heat-point="heatPoint"
            :hidden-equipment-num="hiddenEquipmentNum"
            :un-hidden-equipment-num="unHiddenEquipmentNum"
            :other-point="otherPoint"
            :hm-points="hmPoints"
            :hr-point="hrPoint"
            :mid-point="midPoint"
            :monitor-total="monitorTotal"
            :safe-monitor-count="safeMonitorCount"
            :risk-monitor-count="riskMonitorCount"
            :last-month-handle-rate="lastMonthHandleRate"
            :handled-point="handledPoint"
            :unhandled-point="unhandledPoint"
            :disposed-site-count="disposedSiteCount"
            :risk-site-count="riskSiteCount"
            :loading="bottomPanelLoading"
            :hidden-loading="hiddenEquipmentLoading"
            :disposal-loading="disposalLoading"
            :risk-loading="riskPushLoading"
            @getMore="getMore"
            @getPushMore="getPushMore"
            @go-to-detail="goToDetail"
            @pie-click="handlePieClick"
          />

          <!--能源-底部板块-->
          <bottom-energy
            v-show = "energyPart"
            :carbon-data = "lastMonthData"
            :energy-trend-list = "energyData"
            :energy-value.sync = "activeEnergyDate"
            :mouth-data = "MouthData"
            :all-energy = "allEnergy"
            :loading="bottomEnergyLoading"
            :mouth-loading="mouthDataLoading"
            :carbon-loading="carbonLoading"
            :trend-loading="trendLoading"
            @change="changeEnergyDate"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopMenu from "@/components/h5/topMenu.vue";
import bdMap from "@/components/home/item4/components/map";
import Bus from "@/utils/bus.js";
import GlassPopup from "@/components/h5/GlassPopup.vue";
import LeftPanel from "@/components/h5/LeftPanel.vue";
import BottomPanel from "@/components/h5/BottomPanel.vue";
import LeftEnergy from "@/components/h5/LeftEnergy.vue";
import BottomEnergy from "@/components/h5/BottomEnergy.vue";
import IndexBadge from "@/components/h5/IndexBadge.vue"
import IconSet from "@/components/h5/IconSet.vue"
import SkeletonLoader from "@/components/h5/SkeletonLoader.vue"
import SiteListDrawer from "@/components/h5/SiteListDrawer.vue"

import * as api from '@/scripts/home'
import { globalI18n } from '@/scripts/i18n'
import Vue from "vue";
import Axios from "utils/Axios";

export default {
  data() {
    return {
      i18n: globalI18n,
      lang: globalI18n.getLang(),

      menusList:[],
      dashboardMenus: ['HOME_PAGE'],
      dashboardMenuItems: [
        { label: '控制台', route: 0, key: 'HOME_PAGE' },
      ],
      userName:"",
      userId:"",
      roleType:"",
      titleData:[],
      riskList:[],
      RiskTable:[],
      tableList:[],
      showtc:false,
      showpage2:false,
      showpage:[false,false,false,false,false],
      page:1,
      pageSize:5,
      // ponytail: showtc 弹窗独立分页参数
      tcPage:1,
      tcPageSize:20,
      tcTotal:0,
      alertLevel:'',
      deptId:null,
      pageall: 0,
      showMapPopup: false,
      showNearbyList: false,
      nearbyList: [],
      selectedPoint:{
        deptId: '',
        deptName: ''
      },
      safePart: true,
      energyPart: false,
      mapPointList:{
        totalPoint:'',
        highRiskPoint:''
      },

      filterText: '',
      monitorTotal:null,
      riskMonitorCount:null,
      safeMonitorCount:null,
      organizationTree:[],
      pieData:[],

      hiddenData:[],
      EquipmentData:[],
      highRiskData:[],
      hrPointData: [],
      midPointData:[],
      combinedData:[],
      hrPoint: 0,
      midPoint: 0,
      hmPoints: 0,
      PointTotal: 0,
      powerPoint: 0,
      heatPoint: 0,
      totalTypePoint: 0,
      hiddenEquipmentNum: '',
      unHiddenEquipmentNum: '',
      otherPoint: 0,

      enterpriseTotal: 0,
      lastMonthNew: 0,
      lastMonthHandleRate: null,
      handledPoint: null,
      unhandledPoint: null,
      disposedSiteCount: null,
      riskSiteCount: null,

      MouthData: [],
      allEnergy: 0,
      lastMonthData: [],
      lastMonth: '',
      allEnergyData: null,
      energyData: [],
      activeEnergyDate: 0,

      safeImg: require('../../assets/images/h5/buttonC.png'),
      energyImg: require('../../assets/images/h5/buttonU.png'),
      chooseImg: require('../../assets/images/h5/buttonC.png'),
      unChooseImg: require('../../assets/images/h5/buttonU.png'),
      drawerVisible: false,
      drawerTitle: '监测点列表',
      drawerTabs: [],
      drawerDefaultTab: 0,
    }
  },
  components: {
    TopMenu,
    LeftPanel,
    BottomPanel,
    LeftEnergy,
    BottomEnergy,
    GlassPopup,
    bdMap,
    IndexBadge,
    IconSet,
    SkeletonLoader,
    SiteListDrawer,
  },
  computed: {
    t() {
      void this.lang
      return this.i18n.t;
    },

    changeText(){
      return this.lang === 'zh' ? 'font-zh' : 'font-en'
    },

    // ponytail: loading flags for each data module — skeleton shown until first real data arrives
    leftPanelLoading() {
      return this.organizationTree.length === 0 && this.enterpriseTotal === 0
    },
    bottomPanelLoading() {
      return this.pieData.length === 0 && this.highRiskData.length === 0 && this.combinedData.length === 0
    },
    hiddenEquipmentLoading() {
      return this.hiddenData.length === 0 && this.hiddenEquipmentNum === ''
    },
    disposalLoading() {
      return this.handledPoint === null && this.disposedSiteCount === null
    },
    riskPushLoading() {
      return this.riskList.length === 0
    },
    titleDataLoading() {
      return this.titleData.length === 0
    },
    leftEnergyLoading() {
      return !this.allEnergyData && this.lastMonthData.length === 0
    },
    bottomEnergyLoading() {
      return this.MouthData.length === 0 && this.energyData.length === 0
    },
    // ponytail: independent loading flags for BottomEnergy sub-modules
    mouthDataLoading() {
      return this.MouthData.length === 0
    },
    carbonLoading() {
      return this.lastMonthData.length === 0
    },
    trendLoading() {
      return this.energyData.length === 0
    },
  },
  mounted() {
    this.menusList=JSON.parse(localStorage.getItem("menusList"))
    this.userName = localStorage.getItem("userName");
    this.deptId = localStorage.getItem('deptId');

    const cachedRoleType = sessionStorage.getItem("url");
    if (cachedRoleType == '2') {
      this.$router.push('/single-home');
      return;
    }

    if (!this.menusList || !this.userName || !this.deptId){
      console.log('直接通过token进行访问');
      this.getUserMenus();
      this.getUserInfo();
    }

    // ponytail: only fetch safe-tab data on mount; energy data fetched on first tab switch
    this.getTree()
    this.queryRealtimeList()
    this.queryNewTimeList()
    this.getDayRiskData()
    this.getStaNum()
    this.getRiskPoint()
    this.fetchRiskPointNum()
    this.fetchHiddenEquipment()
    this.getEnterpriseStatistic()
    this.getNowTime()

    Bus.$on('mapPointClick', (data) => {
      if (data._items && data._items.length > 1) {
        this.nearbyList = data._items
        this.showNearbyList = true
      } else {
        this.selectEnterprise(data)
      }
    })
  },
  //组件销毁前移除时间监听
  beforeDestroy() {
    Bus.$off('mapPointClick');
  },
  methods: {
    getUserMenus(){
      api.getUserMenusApi().then(res =>{
        if (!res.data) return
        this.menusList = res.data.menus.map(item => item.menuCode)
        Vue.prototype.menusList = this.menusList
        localStorage.setItem("menusList", JSON.stringify(this.menusList));
      })
    },

    getUserInfo(){
      api.getUserInfoApi().then(res =>{
        if (!res.data) return
        this.userName = res.data.userName;
        this.roleType = res.data.roleType;
        this.userId = res.data.userId;
        this.deptId = res.data.deptId;
        localStorage.setItem("userId", res.data.userId);
        localStorage.setItem("deptId", res.data.deptId);
        localStorage.setItem("userName", this.userName);
        sessionStorage.setItem("url", res.data.roleType);

        if (res.data.roleType == '2' || res.data.roleType === 2) {
          this.$router.push('/single-home');
        }
      })
    },

    changeLang(){
      this.i18n.toggle();
      this.$root.$emit('lang-change')
      this.lang = this.i18n.getLang()
      this.$forceUpdate();

      //重新渲染图饼
      this.leftCav(this.riskMonitorCount, this.safeMonitorCount)
      this.fetchHiddenEquipment()
      this.fetchRiskPointNum()
      this.getEnterpriseStatistic()
    },

    showPersonCenter() {
      this.$router.push("/console/profile");
    },
    toLogin(){
      this.$router.push("/login");
    },
    toDetail(data){
      this.$router.push({
        name: "SiteListPage",
        params: {
          val: [
            data.siteName,
            data.branchId,
            data.id,
            "/console/sites/list",
          ],
        },
      });
      Bus.$emit("changeheader", "2");
    },
    getStaNum(){
      api.getStaNumApi(this.deptId).then(res =>{
        if (!res.data) return
        this.monitorTotal = res.data.total || 0;
        this.safeMonitorCount =(Number(res.data.riskMaxLevelCountMap['0']) || 0) + (Number(res.data.riskMaxLevelCountMap['1']) || 0);
        this.riskMonitorCount = (Number(res.data.total) || 0) - (Number(res.data.riskMaxLevelCountMap['0']) || 0) - (Number(res.data.riskMaxLevelCountMap['1']) || 0);
        this.leftCav(this.riskMonitorCount,this.safeMonitorCount)
      })
    },
    getRiskList(){
      api.getRiskListApi({
        page: this.page,
        pageSize: this.pageSize,
        deptId: this.deptId,
        alertLevel: this.alertLevel
      }).then(res => {
        if (!res.data) return
        this.RiskTable=res.data.dataList || []
        this.pageall=res.data.totalNum || 0
      })
    },

    getRiskPoint() {
      const makeParam = level => ({ deptId: this.deptId, alertLevel: level })
      Promise.all([
        api.getRiskPointApi(makeParam(4)),
        api.getRiskPointApi(makeParam(3))
      ]).then(([res4, res3]) => {
        if (!res4.data && !res3.data) return
        const hrPointData = res4.data.dataList || []
        const midPointData = res3.data.dataList || []
        this.combinedData = hrPointData.concat(midPointData)
      }).catch(error => {
        console.error("Error fetching data:", error);
      })
    },

    fetchRiskPointNum(){
      api.riskStatusApi(this.deptId).then(res => {
        if(res.data){
          this.PointTotal = res.data.total;
          this.hmPoints = (Number(res.data.riskMaxLevelCountMap['4']) || 0) + (Number(res.data.riskMaxLevelCountMap['5']) || 0);
          this.hrPoint = res.data.riskMaxLevelCountMap['5'] || 0;
          this.midPoint = res.data.riskMaxLevelCountMap['4'] || 0;
          this.hiddenEquipmentNum = res.data.riskDeviceSiteCount || 0;
          this.unHiddenEquipmentNum = (Number(res.data.total) || 0) - (Number(res.data.riskDeviceSiteCount) || 0);
          this.highRiskData=[
            {
              name: this.t('highPoint'),
              value: this.hrPoint,
              color: '#DC5A5A'
            },
            {
              name: this.t('midPoint'),
              value: this.midPoint,
              color: '#D4A34A'
            }
          ];
          this.EquipmentData=[
            {
              name: this.t('hiddenEquipmentY'),
              value: this.hiddenEquipmentNum,
              color: '#73B9E6'
            },
            {
              name: this.t('hiddenEquipmentN'),
              value: this.unHiddenEquipmentNum,
              color: '#6FC98F'
            }
          ]
        }
      })
    },

    fetchHiddenEquipment(){
      api.getHiddenEquipmentApi(this.deptId).then(res => {
        if (!res.data) return
        this.powerPoint = res.data.typeCountMap['2'];
        this.heatPoint = res.data.typeCountMap['1'];
        this.otherPoint = res.data.typeCountMap['0'];
        this.totalTypePoint = res.data.typeCountMap['0'] + res.data.typeCountMap['1'] + res.data.typeCountMap['2'];
        this.hiddenData=[
          {
            name: this.t('powerPoint'),
            value: this.powerPoint,
            color: '#73B9E6'
          },
          {
            name: this.t('heatPoint'),
            value: this.heatPoint,
            color: '#D99A5C'
          },
          {
            name: '其他',
            value: this.otherPoint,
            color: '#8B8B8B'
          }
        ]
      })
    },

    selectpage(item){
      this.alertLevel=item.alertLevel
      this.showtc=false
      this.page=1
      this.getRiskList()
      this.showpage2=true
      this.showpage=[false,false,false,false,false]
    },
    opentc(val){
      for(let i=0;i<this.showpage.length;i++){
        if(val==i){
          this.showpage[i]=!this.showpage[i]
        }
      }
      this.$forceUpdate();
    },
    getMore(){
      sessionStorage.setItem("active", '3');
      this.$router.push("/console/alerts/equipment");
    },
    getPushMore(){
      this.$router.push("/console/alerts/hazard");
    },
    queryNewTimeList() {
      api.getNewTimeListApi(this.deptId).then(res => {
        if (!res.data) return
        this.riskList = res.data;
      })
    },
    // 初始化一个 websocket 对象，同时给基本属性赋值
    initWebSocket: function () {
      var token = localStorage.getItem("token");
      this.websock = new WebSocket("wss://"+this.wssadress+"/websocket/risk?authorization=" + token);
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
    },
    websocketonopen: function () {
    },
    websocketonerror: function () {
    },
    websocketonmessage: function (e) {
      let that = this;
      let mess = e.data;
      let messsdata = eval("("+mess+")");
      messsdata.createTime= that.formatDate(messsdata.createTime)
      that.riskList.pop()
      that.riskList.unshift(messsdata)
      that.$notify({
        title: "隐患地点:" + messsdata.deptNameLink.join(','),
        message:
          "隐患名称:" +
          messsdata.simpleMess +
          ";发生时间:" +
          messsdata.createTime,
        position: "bottom-right",
        type: "warning",
        duration:8000,
        onClick: function () {
        },
      });
    },
    formatDate (d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':';
      var ss =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    queryRealtimeList(id, page, pageSize) {
      // ponytail: 使用已存在的 getMonitorSitePageApi 做分页，替换原硬编码 500 条查询
      api.getMonitorSitePageApi({
        deptId: id,
        pageNum: page,
        showNum: pageSize
      }).then(res => {
        if (!res.data) { this.tableList = []; this.tcTotal = 0; return }
        this.tableList = res.data.dataList || [];
        this.tcTotal = res.data.totalNum || 0;
      })
    },
    getTree(){
      let param = {};
      param.method = "get";
      param.url = "/dept/getDeptTree";
      param.params = {
        "ignoreEmptyRegion": true
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.organizationTree = res.data;
        }
      });
    },
    getDayRiskData(){
      api.getDayRiskDataApi(this.deptId).then(res => {
        if (!res.data) return
        this.titleData=res.data
      })
    },
    searchData(){
      this.$refs.leftPanel.$refs.orgtree.filter(this.filterText);
    },
    pageChange(val){
      this.page=val
      this.getRiskList()
    },
    handleTcSizeChange(size) {
      this.tcPageSize = size
      this.tcPage = 1
      this.queryRealtimeList(this.deptId, this.tcPage, this.tcPageSize)
    },
    handleTcCurrentChange(page) {
      this.tcPage = page
      this.queryRealtimeList(this.deptId, this.tcPage, this.tcPageSize)
    },
    handleNodeClick(data){
      this.showtc=true
      this.showpage2=false
      this.deptId = data.deptId
      this.tcPage = 1
      this.queryRealtimeList(data.deptId, this.tcPage, this.tcPageSize)
      this.getDayRiskData()
      this.getStaNum()
      this.fetchRiskPointNum()
      this.getRiskPoint()
      this.queryNewTimeList()
      this.fetchHiddenEquipment()
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    leftCav(risk,safe){
      this.pieData = [
        {
          name: this.t('hiddenPoint'),
          value: risk,
          color: '#D4895A'
        },
        {
          name: this.t('safePoint'),
          value: safe,
          color: '#6FC98F'
        },
      ]
    },
    getPointList(id){
      api.riskStatusApi(id).then(res => {
        if (res.data){
          this.mapPointList.totalPoint = res.data.total || 0;
          this.mapPointList.highRiskPoint = (Number(res.data.riskMaxLevelCountMap['4']) || 0) + (Number(res.data.riskMaxLevelCountMap['5']) || 0);
        } else {
          console.log('获取数据失败：',res.data);
        }
      })
    },
    /* ponytail: select enterprise from map — keep nearby list open, stack detail on top */
    selectEnterprise(item) {
      this.selectedPoint = { deptId: item.deptId, deptName: item.deptName }
      this.showMapPopup = true
      this.getPointList(item.deptId)
    },
    /* ponytail: 改用 query 传递 deptId，替代 sessionStorage */
    goStation(){
      this.$router.push({
        path: '/console/sites/list',
        query: { deptId: this.selectedPoint.deptId, deptName: this.selectedPoint.deptName },
      })
    },
    goToDetail(item){
      this.$router.push({
        path: '/console/sites/list',
        query: { deptId: item.deptId, deptName: item.deptName },
      })
    },

    handlePieClick({ type, item }) {
      const t = this.t
      // ponytail: 仅保留中高危风险饼图弹窗，隐患监测点、处置率弹窗已移除
      if (type !== 'highRisk') return
      const isHigh = item.name === t('highPoint')
      this.drawerTitle = t('pointAnalysis')
      this.drawerTabs = [
        { label: '严重风险', value: 'high', count: this.hrPoint, riskLevel: 5 },
        { label: '较大风险', value: 'mid', count: this.midPoint, containsRiskLevels: [4], excludeRiskLevels: [5] }
      ]
      this.drawerDefaultTab = isHigh ? 0 : 1
      this.drawerVisible = true
    },

    goToSafe(){
      this.safePart = true;
      this.energyPart = false;
      this.safeImg = this.chooseImg;
      this.energyImg = this.unChooseImg;
    },

    goToEnergy(){
      this.safePart = false;
      this.energyPart = true;
      this.showpage = [false, false, false, false, false];
      this.showpage2 = false;
      this.showtc = false;

      // ponytail: lazy-fetch energy data only when tab is activated
      this.getLastMonth()
      this.getAllEnergyData()
      this.searchEnergyData()
      this.getMonthData()
      this.safeImg = this.unChooseImg;
      this.energyImg = this.chooseImg;
    },

    getLastMonth(){
      api.getLastMonthApi(this.lastMonth, this.deptId).then(res => {
        if(!res.data) return
        this.lastMonthData = res.data.deptProportions
      })
    },

    getNowTime() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var date = now.getDate();
      var lastmonth = now.getMonth();
      var hour = now.getHours();
      var minu = now.getMinutes();
      var sec = now.getSeconds();
      var MS = now.getMilliseconds();
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;
      if(lastmonth === 0){
        lastmonth = 12
        this.lastMonth = year-1 + "-" + lastmonth;
      }else if(lastmonth < 10){
        this.lastMonth = year + "-" + "0" + lastmonth;
      }else{
        this.lastMonth = year + "-" + lastmonth;
      }
      var time = "";
      time = year + "-" + month + "-" + date ;
      this.month=year + "-" + month
      this.hour=time
      this.time = time;
      this.year=year
    },

    getAllEnergyData(){
      api.getAllEnergyDataApi().then(res => {
        if (!res.data) return
        this.allEnergyData = res.data
      })
    },

    changeEnergyDate(idx) {
      this.activeEnergyDate = idx
      this.searchEnergyData()
    },

    searchEnergyData(){
      api.searchEnergyDataApi(
        this.activeEnergyDate,
        [this.time,this.month,this.year][this.activeEnergyDate],
        this.deptId
      ).then(res => {
        if (!res.data) return
        this.energyData = res.data.energyTrends || []
      })
    },

    getMonthData(){
      api.getMonthDataApi(this.month, this.deptId).then(res => {
        if (!res.data) return
        this.allEnergy = res.data.wholeDegree
        this.MouthData = res.data.deptProportions
      })
    },

    getEnterpriseStatistic(){
      api.getEnterpriseStatisticApi().then(res => {
        if (!res.data) return
        this.enterpriseTotal = res.data.total || 0
        this.lastMonthNew = res.data.lastMonthNew || 0
        const rate = res.data.lastMonthHandleRate || 0
        this.lastMonthHandleRate = rate
        this.disposedSiteCount = res.data.disposedSiteCount || 0
        this.riskSiteCount = res.data.riskSiteCount || 0
        this.handledPoint = this.disposedSiteCount
        this.unhandledPoint = this.riskSiteCount - this.disposedSiteCount
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "AlibabaPuHuiTi-2-55-Regular";
  src: url("../../assets/iconfont/AlibabaPuHuiTi-2-55-Regular.ttf");
  font-display: block;
}
@font-face {
  font-family: "AlibabaPuHuiTi-2-65-Medium";
  src: url("../../assets/iconfont/AlibabaPuHuiTi-2-65-Medium.ttf");
  font-display: block;
}
@font-face {
  font-family: "AlibabaPuHuiTi-2-85-Bold";
  src: url("../../assets/iconfont/AlibabaPuHuiTi-2-85-Bold.ttf");
  font-display: block;
}
@font-face {
  font-family: "FROSTBITE-Narrow";
  src: url("../../assets/iconfont/Expansiva.otf");
  font-display: block;
}
@font-face {
  font-family: "FROSTBITE-Narrow Bold";
  src: url("../../assets/iconfont/Expansiva.otf");
  font-display: block;
}
@font-face {
  font-family: "PangMenZhengDaoBiaoTiTi-1";
  src: url("../../assets/iconfont/PangMenZhengDaoBiaoTiTi-1.ttf");
  font-display: block;
}
.home {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  position: fixed;
  overflow: auto;
  background-color: var(--color-dark-bg, #0A1628);
  background-image:
    radial-gradient(ellipse at 20% 0%, rgba(42,98,255,0.05) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 100%, rgba(42,98,255,0.04) 0%, transparent 50%);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;
}

.glass-map-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 20px 16px;
  gap: 16px;
  color: white;
}

.glass-map-title {
  font-size: 16px;
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
  color: var(--color-dark-text-accent, #8AB4FF);
  margin-bottom: 4px;
  text-align: left;
}

.map-stats-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 0;
}

.map-stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 12px 8px;
  background: rgba(42, 98, 255, 0.06);
  border: 1px solid rgba(42, 98, 255, 0.1);
  border-radius: 8px;
  min-width: 0;
}

.stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  white-space: nowrap;
}

.stat-value {
  font-size: 20px;
  font-family: "FROSTBITE-Narrow", sans-serif;
  color: var(--color-dark-text-primary, rgba(255,255,255,0.85));
  line-height: 1;
}

.stat-warn .stat-value.stat-danger {
  color: #FF6B6B;
}

.mapButton {
  width: 100%;
  margin-top: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.topCenter{
  max-height: 100%;
  min-width: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
  font-size: 16px;
  color: rgba(255, 231, 185, 0.80);

  .topPart{
    display: flex;
    width: auto;
    min-width: 0;
    flex-direction: column;
    align-items: center;
    padding: 10px 16px;

    .itemNum{
      height: 36px;
      width: 80px;
      min-width: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-family: "FROSTBITE-Narrow", sans-serif;
      color: #FFFFFF;
      cursor: pointer;
      background: rgba(255, 193, 7, 0.12);
      border: 1px solid rgba(255, 193, 7, 0.25);
      border-radius: 6px;
      margin-top: 8px;
      transition: background 0.35s cubic-bezier(0.16, 1, 0.3, 1),
                  border-color 0.35s cubic-bezier(0.16, 1, 0.3, 1),
                  box-shadow 0.35s cubic-bezier(0.16, 1, 0.3, 1);

      &:hover {
        background: rgba(255, 193, 7, 0.2);
        border-color: rgba(255, 193, 7, 0.45);
        box-shadow: 0 0 14px rgba(255, 193, 7, 0.2);
      }
    }
  }

  .page1{
    margin-top: 6px;
    width: 100%;
    min-width: 100px;
    max-width: 160px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: rgba(3, 15, 25, 0.6);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(42, 98, 255, 0.12);
    border-radius: 8px;
    padding: 6px;

    .pageItem{
      height: 32px;
      cursor: pointer;
      font-size: 13px;
      font-weight: 500;
      color: rgba(255,255,255,0.85);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      border-radius: 4px;
      background: rgba(42, 98, 255, 0.04);
      transition: background 0.2s cubic-bezier(0.4,0,0.2,1);

      &:hover {
        background: rgba(42, 98, 255, 0.12);
      }
    }
  }
}

.homeItem{
  flex: 1;
  z-index: 2;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px 24px 24px;
  pointer-events: none;

  .topItem{
    height: 65%;
    width: 100%;
    min-height: 0;
    min-width: 0;
    display: flex;
    gap: 16px;

    .topLeft{
      pointer-events: auto;
      width: 20%;
      height: 100%;
      min-height: 0;
      min-width: 0;
      display: flex;
    }

    .topRight{
      flex: 1;
      position: relative;
      pointer-events: none;

      .topCenter{
        pointer-events: none;
        margin: 8px auto 0;
        .topPart {
          pointer-events: none;
          .itemNum {
            pointer-events: auto;
          }
          .page1 {
            pointer-events: auto;
          }
        }
      }

      .change-part{
        pointer-events: auto;
      }
    }
  }

  .bottomItem{
    pointer-events: auto;
    height: 35%;
    width: 100%;
    min-width: 0;
    min-height: 0;
  }
}

.glass-title-icon {
  flex-shrink: 0;
  opacity: 0.7;
}

.listCon{
  margin-top: 4px;
  padding: 0 20px 12px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.listCon::-webkit-scrollbar {
  width: 4px;
}
.listCon::-webkit-scrollbar-track {
  background: transparent;
}
.listCon::-webkit-scrollbar-thumb {
  background: var(--color-scrollbar-thumb, rgba(42, 98, 255, 0.5));
  border-radius: 2px;
}

.listItem{
  display: flex;
  align-items: center;
  gap: 0;
}

.listItem > span{
  display: flex;
  align-items: center;
  line-height: 28px;
  height: 28px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bluebg{
  background: var(--color-dark-table-header, rgba(42, 98, 255, 0.2));
  color: var(--color-dark-text-accent, #8AB4FF);
  border-radius: 6px;
  margin-top: 8px;
  padding: 0 0;
  height: 32px;
}
.bluebg > span {
  height: 32px;
  line-height: 32px;
}

.firsp{
  width: 50px;
  justify-content: center;
  flex-shrink: 0;
}
.secsp{
  width: 140px;
  flex-shrink: 0;
  display: block;
  min-width: 0;
}
.thisp{
  flex: 1;
  min-width: 0;
}
.forsp{
  width: 80px;
  flex-shrink: 0;
  justify-content: flex-end;
  padding-right: 4px;
}

.trFont{
  margin-top: 6px;
  color: rgba(208, 222, 238, 0.9);
  font-size: 13px;
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  border-radius: 6px;
  padding: 0 0;
  transition: background 0.15s ease;
  cursor: default;
}
.trFont:hover {
  background: rgba(42, 98, 255, 0.06);
}

.sta-action-btn {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  background: rgba(42, 98, 255, 0.12);
  border: 1px solid rgba(42, 98, 255, 0.25);
  border-radius: 4px;
  color: var(--color-dark-text-accent, #8AB4FF);
  font-size: 12px;
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}
.sta-action-btn:hover {
  background: rgba(42, 98, 255, 0.22);
  border-color: rgba(42, 98, 255, 0.4);
  color: rgba(255, 255, 255, 0.9);
}

.risk-level-badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  font-size: 11px;
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  color: rgba(255,255,255,0.85);
}
.risk-level-badge.risk-高,
.risk-level-badge.risk-高危 {
  background: rgba(255, 68, 68, 0.18);
  color: #FF6B6B;
}
.risk-level-badge.risk-中,
.risk-level-badge.risk-中危 {
  background: rgba(255, 183, 0, 0.18);
  color: #FFB700;
}
.risk-level-badge.risk-低,
.risk-level-badge.risk-低危 {
  background: rgba(42, 98, 255, 0.14);
  color: #8AB4FF;
}

.sta-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 8px 20px 12px;
  flex-shrink: 0;
}

.tc-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 20px 12px;
  flex-shrink: 0;
}

.translateBtn{
  width: 30px;
  height: 30px;
  position: absolute;
  top: 80px;
  right: 10px;
  cursor: pointer;
}

.change-part{
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 200px;
  height: 48px;
  display: flex;
  gap: 4px;
  background: rgba(10, 22, 40, 0.55);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(42, 98, 255, 0.1);
  border-radius: 24px;
  padding: 4px;

  .change-item{
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    border-radius: 20px;
    transition: all 0.3s cubic-bezier(0.4,0,0.2,1);
  }

  .change-bg{
    display: none;
  }

  .change-text{
    font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    transition: color 0.3s cubic-bezier(0.4,0,0.2,1);
    z-index: 2;
    position: relative;
  }

  .change-img{
    display: none;
  }

  .change-item.active {
    background: rgba(42, 98, 255, 0.15);
    box-shadow: 0 0 12px rgba(42, 98, 255, 0.12);

    .change-text {
      color: rgba(255, 255, 255, 0.9);
    }
  }

  .change-item:not(.active):hover {
    background: rgba(42, 98, 255, 0.08);

    .change-text {
      color: rgba(255, 255, 255, 0.65);
    }
  }
}

.showDemo{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.demoItem{
  width: 600px;
  height: 400px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  background-image: url("../../assets/images/h5/tcbg.webp");
  background-size: 100% 100%;
  background-color: rgba(3, 15, 25, 0.70);
}

.demoClose{
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.demoTitle{
  width: 100%;
  min-width: 0;
  height: 10%;
  padding-left: 10px;
  display: flex;
  align-items: end;
  color: var(--color-dark-text-accent, #8AB4FF);
  font-size: 20px;
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
}

.demoContent{
  width: 100%;
  height: 80%;
  min-width: 0;
  min-height: 0;
  margin-top: 10px;
  padding: 10px;
  font-size: 16px;
  color: var(--color-dark-text-accent, #8AB4FF);
}
</style>
<style>
.anchorBL{
  display: none;
}
.BMap_cpyCtrl{
  display: none;
}
#app .searchBlank .el-input.el-input__inner, #app .searchBlank .el-input > .el-input__inner, #app .searchBlank .el-date-editor.el-input__inner, #app .searchBlank .el-date-editor > .el-input__inner{
  background-color: rgba(0,0,0,0);
  border: none;
}

#app .searchBlank .el-input__inner::placeholder{
  color: var(--color-dark-text-muted, #77A8FF);
  opacity: 0.6;
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  font-size: 14px;
}
#app .searchBlank .el-tree{
  background-color: rgba(0,0,0,0);
  height: 100%;
}

#app .searchBlank .el-tree-node__label{
  color:rgba(208, 222, 238, 1) ;

}
#app .searchBlank .is-checked{
  background-color: rgba(0,0,0,0);
}
#app .searchBlank .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  background-color: rgba(0,0,0,0);
}
#app .searchBlank  .el-tree-node__content:hover{
  background-color: rgba(0,0,0,0);
}
#app .glass-drawer .el-pagination.is-background .el-pager li:not(.disabled).active{

  background-color: var(--color-primary, #2A62FF);
  color: #fff;
  font-size: 14px;
}
#app .glass-drawer  .el-pagination.is-background .btn-next,#app .glass-drawer  .el-pagination.is-background .btn-prev,#app .glass-drawer  .el-pagination.is-background .el-pager li{

  background: rgba(42,98,255,0.3);
  color: var(--color-dark-text-accent, #8AB4FF);
}
#app .glass-drawer .el-pagination.is-background .el-pager li:not(.disabled):hover {
  background: rgba(42,98,255,0.5);
  color: #fff;
}
#app .glass-drawer .el-pagination .el-pagination__total,
#app .glass-drawer .el-pagination .el-pagination__sizes .el-select .el-input .el-input__inner,
#app .glass-drawer .el-pagination .el-pagination__jump {
  color: rgba(208, 222, 238, 0.8);
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  font-size: 13px;
}
#app .glass-drawer .el-pagination .el-pagination__sizes .el-select .el-input .el-input__inner {
  background: rgba(42,98,255,0.2);
  border-color: rgba(42,98,255,0.25);
  color: rgba(208, 222, 238, 0.9);
}
#app .glass-drawer .el-pagination .el-pagination__jump .el-input__inner {
  background: rgba(42,98,255,0.2);
  border-color: rgba(42,98,255,0.25);
  color: rgba(208, 222, 238, 0.9);
}
#app .glass-drawer .el-pagination .el-input .el-input__inner:focus {
  border-color: var(--color-primary, #2A62FF);
}

.scrollSp ::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.scrollSp ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: var(--color-scrollbar-thumb, rgba(42, 98, 255, 0.3));
}

.scrollSp ::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}
</style>
